import { createContext, useState } from 'react';
import api from 'services/api';

export const FormaDeEnvioContext = createContext();

export const FormaDeEnvioProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [formaDeEnvio, setFormaDeEnvio] = useState({
    data: [],
    colunas: [],
    filter: {},
    page: 0,
    size: 10,
  });

  const getFormaDeEnvio = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: formaDeEnvio?.filter,
        page: formaDeEnvio?.page,
        size: formaDeEnvio?.size,
        order: formaDeEnvio?.order,
        ...payload,
      });
      setFormaDeEnvio((prev) => ({ ...prev, ...payload, ...data }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <FormaDeEnvioContext.Provider
      value={{ getLoading, formaDeEnvio, getFormaDeEnvio }}
    >
      {children}
    </FormaDeEnvioContext.Provider>
  );
};
